import { ErrorHandlerInterface, OrderData } from '../exports/Interfaces';
import BackendApiClient from './BackendApiClient';
import { SuccessfulResponse, ValidationErrorResponse } from '../exports/Types';

class OrderValidationManager {
  public async validate(
    data: OrderData,
    errorHandlers?: ErrorHandlerInterface,
  ): Promise<SuccessfulResponse<any, 200> | ValidationErrorResponse> {
    return await BackendApiClient.request(
      {
        method: 'POST',
        url: '/order-validations',
        data,
      },
      false,
      errorHandlers,
    );
  }
}

export default new OrderValidationManager();
